import React from 'react';

import BranchInfoSection from './Sections/BranchInfoSection';
import ProductsInfoSection from './Sections/ProductsInfoSection';
import EditableFieldsSection from './Sections/EditableFieldsSection';
import RequestedInfoSection from './Sections/RequestedInfoSection';
import ApprovedInfoSection from './Sections/ApprovedInfoSection';
import ConfirmedInfoSection from './Sections/ConfirmedInfoSection';
import { useInventoryTransfer } from '../../../../../hooks/inventory/useInventoryTransfer';
import FormModal from '../../../../Modals/FormModal';

const InventoryTransferEditModal: React.FC = () => {
  const {
    form,
    formErrors,
    showUpdateModal,
    closeUpdateModal,
    updateField,
    handlerUpdate,
    isSubmitting,
  } = useInventoryTransfer();

  if (!form) return null;

  const handleSave = () => {
    handlerUpdate(form.id, {
      reason: form.reason,
    });
  };

  return (
    <FormModal
      isOpen={showUpdateModal}
      onClose={closeUpdateModal}
      title="Editar Traslado"
      maxWidth="max-w-3xl"
      zIndex='front'
    >
      <BranchInfoSection form={form} />

      <ProductsInfoSection form={form} />

      <EditableFieldsSection
        form={form}
        formErrors={formErrors}
        updateField={updateField}
      />

      <RequestedInfoSection form={form} />
      <ApprovedInfoSection form={form} />
      <ConfirmedInfoSection form={form} />

      <div className="mt-8 flex justify-end">
        <button
          onClick={handleSave}
          disabled={isSubmitting}
          className="rounded bg-primary px-6 py-2 text-white hover:bg-opacity-90"
        >
          Guardar Cambios
        </button>
      </div>
    </FormModal>
  );
};

export default InventoryTransferEditModal;
